// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"Gx","carousel__wrapper_on_sides":"Hx","arrows_wrapper":"Ix","arrows_wrapper_right":"Jx","arrows_wrapper_vertical":"Kx","arrows_wrapper_on_sides":"Lx","arrow_button":"Mx","carousel_arrow_left":"Nx","carousel_arrow_left_on_side":"Ox","carousel_arrow_right_on_side":"Px","carousel_arrow":"Qx","arrows_wrapper_rounded":"Rx","carousel__fullWidth":"Sx"};
    if(module.hot) {
      // 1713969932020
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  